<template>
  <b-overlay
    variant="white"
    :show="isLoading"
    spinner-variant="primary"
    blur="0"
    opacity=".5"
    rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card title="Generate NPP">
          <b-row
            class="mb-1 justify-content-between align-items-end"
          >
            <b-col md="4" lg="3" class="mb-1 mb-md-0">
            </b-col>
            <b-col md="6" lg="5">
              <b-input-group size="8">
                <b-form-input
                  v-model="search"
                  type="search"
                  :placeholder="'Cari disini...'"
                />
                <b-input-group-append>
                  <b-button :disabled="!search" @click="search = ''">
                    Hapus
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-col>
          </b-row>
          <div v-if="role_name == 'Admin Nasional'">
            <b-table
              ref="tableData"
              :items="items" 
              :fields="fieldsAdmin" 
              responsive
              striped
              show-empty
              :busy="busy1"
            >
              <!-- Checkbox di Header -->
              <template #head(select)>
                <b-form-checkbox v-model="selectAll" @change="toggleSelectAll"></b-form-checkbox>
              </template>
              
              <!-- Checkbox di Setiap Baris -->
              <template #cell(select)="data">
                <b-form-checkbox v-model="data.item.selected" @change="getSelectedItems"></b-form-checkbox>
              </template>

              <template #cell(no)="data">
                {{ data.index + 1 }}
              </template>
              <template #cell(employee)="data">
                {{ data.item.employee }} / {{ data.item.name }}
              </template>
              <template #cell(daily_money)="data">
                <span class="text-capitalize d-block" style="text-align: end;">
                  {{ data.item.daily_money | currency }}
                </span>
              </template>
              <template #cell(total_accomodation)="data">
                <span class="text-capitalize d-block" style="text-align: end;">
                  {{ data.item.total_accomodation | currency }}
                </span>
              </template>
              <template #cell(total_real_expense)="data">
                <span class="text-capitalize d-block" style="text-align: end;">
                  {{ data.item.total_real_expense | currency }}
                </span>
              </template>
              <template #cell(total_transportation)="data">
                <span class="text-capitalize d-block" style="text-align: end;">
                  {{ data.item.total_transportation | currency }}
                </span>
              </template>
              <template #cell(total_anggaran)="data">
                <span class="text-capitalize d-block" style="text-align: end;">
                  {{ data.item.total_anggaran | currency }}
                </span>
              </template>
            </b-table>

            <b-card-footer align="right">
              <b-button variant="secondary" @click="goBack()">Batal</b-button>
              <b-button
                v-if="items.length && selectedItem.length"
                variant="primary"
                class="ml-1"
                @click="save()"
                :disabled="isLoading"
              >
                <div v-if="isLoading">
                  Simpan <feather-icon icon="LoaderIcon" />
                </div>
                <div v-else>Simpan</div>
              </b-button>
            </b-card-footer>
          </div>
          <div v-else>
            <b-table 
              ref="tableDataRegional"
              :items="items" 
              :fields="fieldsRegional" 
              responsive
              striped
              show-empty
              :busy="busy2"
            >
              <!-- Checkbox di Header -->
              <template #head(select)>
                <b-form-checkbox v-model="selectAll" @change="toggleSelectAll"></b-form-checkbox>
              </template>
              
              <!-- Checkbox di Setiap Baris -->
              <template #cell(select)="data">
                <b-form-checkbox v-model="data.item.selected" @change="getSelectedItems"></b-form-checkbox>
              </template>

              <template #cell(no)="data">
                {{ data.index + 1 }}
              </template>
              <template #cell(employee)="data">
                {{ data.item.employee }} / {{ data.item.name }}
              </template>
              <template #cell(daily_money)="data">
                <span class="text-capitalize d-block" style="text-align: end;">
                  {{ data.item.daily_money | currency }}
                </span>
              </template>
              <template #cell(total_accomodation)="data">
                <span class="text-capitalize d-block" style="text-align: end;">
                  {{ data.item.total_accomodation | currency }}
                </span>
              </template>
              <template #cell(total_real_expense)="data">
                <span class="text-capitalize d-block" style="text-align: end;">
                  {{ data.item.total_real_expense | currency }}
                </span>
              </template>
              <template #cell(total_transportation)="data">
                <span class="text-capitalize d-block" style="text-align: end;">
                  {{ data.item.total_transportation | currency }}
                </span>
              </template>
              <template #cell(total_anggaran)="data">
                <span class="text-capitalize d-block" style="text-align: end;">
                  {{ data.item.total_anggaran | currency }}
                </span>
              </template>
            </b-table>

            <b-card-footer align="right">
              <b-button variant="secondary" @click="goBack()">Batal</b-button>
              <b-button
                v-if="selectedItem.length"
                variant="primary"
                class="ml-1"
                @click="save()"
                :disabled="isLoading"
              >
                <div v-if="isLoading">
                  Simpan <feather-icon icon="LoaderIcon" />
                </div>
                <div v-else>Simpan</div>
              </b-button>
            </b-card-footer>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
import { BRow, BCol, BCard, BTable, BCardFooter, BButton, BOverlay, BFormCheckbox, BFormInput, BInputGroup, BInputGroupAppend } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import axios from '@axios'
import debounce from 'debounce'

import { getUserData, getUserRole } from '@/auth/utils'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BTable,
    BCardFooter,
    BButton,
    BOverlay,
    BFormCheckbox,
    BFormInput,
    BInputGroup,
    BInputGroupAppend
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      userLoggedIn: getUserData(),
      role_name: getUserRole(),
      isLoading: false,
      selectAll: false,
      busy1: false,
      busy2: false,
      items: [],
      fieldsAdmin: [
        { key: "select", label: "" },
        'no',
        { key: 'project_type', label: 'Sumber Anggaran' },
        { key: 'employee', label: 'NIPPOS / Nama' },
        { key: 'sppd_number', label: 'Nomor SPPD' },
        { key: 'name_subdirektorat', label: 'Sub Direktorat' },
        // { key: 'name_regional', label: 'Regional' },
        { key: 'daily_money', label: 'Uang Harian' },
        { key: 'total_real_expense', label: 'Biaya Pengeluaran Rill' },
        { key: 'total_accomodation', label: 'Biaya Akomodasi' },
        { key: 'total_transportation', label: 'Biaya Transportasi' },
        { key: 'total_anggaran', label: 'Total Biaya' },
      ],
      fieldsRegional: [
        { key: "select", label: "" },
        'no',
        { key: 'project_type', label: 'Sumber Anggaran' },
        { key: 'employee', label: 'NIPPOS / Nama' },
        { key: 'sppd_number', label: 'Nomor SPPD' },
        // { key: 'name_subdirektorat', label: 'Sub Direktorat' },
        { key: 'name_regional', label: 'Regional' },
        { key: 'daily_money', label: 'Uang Harian' },
        { key: 'total_real_expense', label: 'Biaya Pengeluaran Rill' },
        { key: 'total_accomodation', label: 'Biaya Akomodasi' },
        { key: 'total_transportation', label: 'Biaya Transportasi' },
        { key: 'total_anggaran', label: 'Total Biaya' },
      ],
      model: {
        sppds: []
      },
      selectedItem: [],
      search: '',
    }
  },
  watch: {
    search: debounce(function () {
      this.getData();
    }, 500),
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.busy1 = true;
      this.busy2 = true;
      axios.get(`/npps/preview?key=${this.search}`).then(res => {
        // this.items = res.data.data
        const response = res.data;
        // if(this.role_name == "Admin Nasional"){
        //   this.items = response.data.map(item => ({
        //     ...item,
        //     selected: false // Tambahkan properti 'selected' ke setiap item
        //   }));
        // } else {
        //   this.items = response.data.employees
        // }
        if (!response || !Array.isArray(response.data)) {
          this.makeToast('danger', "Error", "Data tidak ditemukan atau format salah.");
          return;
        }

        const allEmployees = response.data.flatMap(group => group.employees || []);

        // if (this.role_name === "Admin Nasional") {
          this.items = allEmployees.map(item => ({
            ...item,
            selected: false
          }));
        // } else {
        //   this.items = allEmployees;
        // }
      })
      .catch(error => {
        this.loading = false
        console.error(error)

        var message = "";
        if(typeof error.response.data.message === 'object'){
          message = error.response.data.message.errors[0].msg
        } else {
          message = error.response.data.message
        }
        this.makeToast('danger', "Terjadi Kesalahan", message)
      })
      .finally(() => {
        this.busy1 = false;
        this.busy2 = false;
      });
    },
    goBack() {
      this.$router.back()
    },
    toggleSelectAll() {
      this.items.forEach(item => {
        item.selected = this.selectAll;
      });

      const selectedIds = this.items
        .filter(item => item.selected); 
      this.selectedItem = selectedIds
      // console.log("ID yang dipilih:", selectedIds);
    },
    getSelectedItems() {
      const selectedIds = this.items
        .filter(item => item.selected); // Ambil hanya 'sppd_id'

      // console.log("ID yang dipilih:", selectedIds);
      this.selectedItem = selectedIds;
    },
    save() {
      this.isLoading = true
      
      // if(this.role_name == "Admin Nasional"){
        const selectedIds = this.selectedItem
          .filter(item => item.selected) // Hanya item yang dipilih
          .map(item => item.sppd_id); // Ambil hanya 'sppd_id'

        this.model.sppds = selectedIds
        // console.log(JSON.stringify(this.model.sppds));
      // }

      axios.post('/npps', this.model).then((response) => {

        const responseMessage = response.data.message; // Mengambil data dari respons
        console.log('Response Data:', response); // Log untuk melihat data

        this.isLoading = false
        this.$router.push({
          name: 'manajemen-npp',
          query: {
            event: 'success',
            title: 'Berhasil',
            text: responseMessage ?? 'NPP berhasil digenerate',
          },
        })
      })
      .catch(error => {
        this.isLoading = false
        console.error(error)
        var message = "";
        var code = 0;
        if(typeof error.response.data.message === 'object'){
          message = error.response.data.message.errors[0].msg
          code = error.response.data.status_code
        } else {
          message = error.response.data.message
          code = error.response.data.status_code
        }

        if (code == 422) {
          this.makeToast('danger', "Informasi", message)
        } else {
          this.makeToast('danger', "Terjadi Kesalahan", message)
        }
      })
    },
    makeToast(variant = null, title = 'Title here...', text = 'Text here...') {
      this.$bvToast.toast(text, {
        title,
        variant,
        solid: true,
      })
    },
  },
}
</script>

<style></style>
